<template>
  <div>
    <div class="info-div">
      <img class="header-img" :src="photoImg" />
      <div class="info-top-box info-top-box1">
        <div class="step-item1 step-other">
          <p class="current-step-p1">当前步数</p>
          <p class="current-step-p2">
            <i>{{getStepInfo.stepCount}}</i>
            <span>步</span>
          </p>
        </div>
        <div class="step-item1">
          <p class="stem-num">
            <span>第</span>
            <i>{{ownRank}}</i>
            <span>名</span>
          </p>
        </div>
      </div>
    </div>
    <div class="update-time">数据更新时间：{{updateTime}}</div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import moment from "moment";
export default {
  props: {
    getStepInfo: {
      type: Object
    }
  },
  data() {
    return {
      stepInfo: JSON.parse(localStorage.getItem("stepAll")),
      ownRank: "",
      loginInfo: JSON.parse(localStorage.getItem("detailInfo")), //获取修改后的详细信息
      photoImg: "",
      updateTime: null
    };
  },
  watch: {
    getStepInfo(val) {
      this.ownRank = val.stepCount === "0" ? "-" : val.rank;
      this.updateTime = moment(val.updateTime).format("YYYY-MM-DD hh:mm:ss");
    }
  },
  computed: {},
  mounted() {
    this.photoImg = this.gainHeaderImg();
    this.init();
  },
  methods: {
    // 获取头像
    gainHeaderImg() {
      return this.loginInfo.fileKey
        ? this.loginInfo.fileKey
        : this.loginInfo.sex == "2"
        ? require("../../../assets/images/doctor.png")
        : require("../../../assets/images/male_img.png");
    },
    init() {}
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/common.styl';

.info-div {
  position: relative;
}

.update-time {
  height: 30px;
  font-size: 13px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(202, 202, 210, 1);
  line-height: 30px;
  text-align: center;
  position: absolute;
  width: 100%;
}

.tag-span2 {
  height: 16px;
  font-size: 11px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(202, 202, 210, 1);
  line-height: 16px;

  b {
    color: $wordsColor;
  }
}

.step-item-tag {
  text-align: left;
  padding-left: 15px;
}

.stem-num-other {
  text-align: center;
  margin-top: 50pxp;
  padding-top: 45px;
  // position :relative;
  // top: 50px;
}

.header-img {
  width: 58px;
  height: 58px;
  border-radius: 50px;
  position: absolute;
  top: -25px;
  left: 0;
  right: 0;
  margin: auto;
  border: 1px solid #fff;
}

.info-top-box {
  display: flex;
  justify-content: center;
  text-align: center;
  margin: auto;
  background: #fff;
  padding: 5px 0 31px;
  box-shadow: 0px 2px 6px 0px rgba(212, 218, 235, 0.5);
  border-radius: 8px;
}

.info-top-box1 {
  padding: 40px 0 20px;
}

.step-other {
  text-align: left;
  padding-left: 50px;
}

.step-item1 {
  flex: 1;
  margin: auto;
}

.current-step-p1 {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(202, 202, 210, 1);
  height: 25px;
}

.current-step-p2 {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);

  i {
    font-size: 30px;
    font-family: DIN-Bold, DIN;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }

  span {
    margin-left: 8px;
    color: 12px;
  }
}

.stem-num {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);

  i {
    font-size: 30px;
    font-family: DIN-Bold, DIN;
    font-weight: bold;
    color: rgba(41, 190, 188, 1);
    margin: 0 6px 0 4px;
    vertical-align: sub;
  }
}
</style>